import * as ApiManager from './_manager';
import store from '../store';

export const filter = {
  listFilms: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/film/filtered/list`,
      payload,
    );
  },
};
